import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Carousel from "@gc-npm/components.carousel";
import MobilesLinesModal from "@/components/Modals/MobilesLinesModal";
import { mobileLinesModalNavigationProps } from '@/utils/mobile-lines-modal';
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { actions as recomendatorActions } from "@/reducers/recomendator";
import { buildAndRenderProductCard } from "@/utils/recomendador";

import { API_STATUS, SCREEN_TYPES } from "@/utils/constants";
import UpgradePrices from "@/components/UpgradePrices";

export const RecomendedProducts = ({ screenType }) => {
  const dispatch = useDispatch();
  const recomendedPackages = useSelector(
    (state) => state.recomendator?.recomendedPackages?.recommendations
  );
  const recomendPackagesStatus = useSelector(
    (state) => state.recomendator?.status?.recomendPackages
  );
  const selectedItems = useSelector(
    (state) => state.recomendator?.selectedItems
  );
  const modulos = useSelector((state) => state.modulos);

  const isLoaded = recomendPackagesStatus === API_STATUS.OK;
  const taggingInfo = { debug: true };
  const isMobile = screenType === SCREEN_TYPES.MOBILE;

  const customOnclickRecom = (extraLines) => {
    dispatch(
      recomendatorActions.recomendPackages({ extraModules: extraLines })
    );
  };

  const onclickMobileLinesModal = (linesToSelect) => {
    dispatch(
      modalActions.addModal({
        id: "MobileLinesModal",
        Element2Show: MobilesLinesModal,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition: isMobile ? "center--bottom" : "center--center",
          inSceneEffect: isMobile ? "fadeInBottom" : "fadeIn",
          outSceneEffect: isMobile ? "fadeOutBottom" : "fadeOut",
          opacityLayoutColor: "blur",
          scrollAllowed: false,
          taggingInfoWhenClickingOutside: {
            ...taggingInfo,
            componentName: "mobileLinesModal",
            componentContent: "cerrar",
          },
          ...mobileLinesModalNavigationProps,
        },
        elementProps: {
          screenType,
          linesToSelect,
          customOnclickRecom,
        },
      })
    );
  };

  return (
    <div className="RecomendedProducts container">
      <div className="RecomendedProducts_carousel">
        <Carousel
          slideSeparation={16}
          breakpoint={820}
          maxPointNum={0}
          className="carousel-recomendaciones"
          pagination
        >
          {recomendedPackages.map((recomendedPackage) =>
            buildAndRenderProductCard(
              dispatch,
              recomendedPackage,
              selectedItems,
              onclickMobileLinesModal,
              isLoaded
            )
          )}
        </Carousel>
        {modulos?.legalTexts && <UpgradePrices />}
      </div>
      <style jsx>
        {`
          .RecomendedProducts {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin-top: 1.5rem;
          }
        `}
      </style>
    </div>
  );
};

export default RecomendedProducts;
